import { PlanEntity } from '../../domain/entities/plan.entity';
import { Mapper } from '../base/mapper';
import { PlanModel } from '../models/plan.model';

export class PlanMapper extends Mapper<PlanModel, PlanEntity> {
  mapFrom(planModel: PlanModel): PlanEntity {
    return {
      idPlan: planModel.id_plan,
      namePlan: planModel.name_plan,
      idCommerce: planModel.id_commerce,
      blockMessagesExceeded: planModel.block_messages_exceeded,
      alerts: planModel.alerts,
    };
  }
}
